import TabsListUnstyled from '@mui/base/TabsListUnstyled';
import TabsUnstyled from '@mui/base/TabsUnstyled';
import TabUnstyled from '@mui/base/TabUnstyled';
import * as React from 'react';
import './index.scss';

export interface TabsProps extends React.PropsWithChildren {
  options: string[];
}

export const Tabs: React.FC<TabsProps> = ({ options, children }) => (
  <TabsUnstyled defaultValue={0}>
    <TabsListUnstyled className="TabList">
      {options.map((v, i) => (
        <TabUnstyled className="Tab" key={i.toString()}>
          {v}
        </TabUnstyled>
      ))}
    </TabsListUnstyled>
    {children}
  </TabsUnstyled>
);
